import Base from 'netxcore@netx/core-app/views/alertView';

import {faExclamationTriangle} from '@fortawesome/pro-solid-svg-icons';
const icons = Base.initializeIcons({
	faExclamationTriangle,
});

export default class AlertView extends Base {
	/** @override */
	constructor(opts = {}) {
		opts.icons = {...icons, ...opts.icons};
		super(opts);
	}
}
